import React from 'react';
import Slider from 'react-slick';
import { makeStyles } from '@mui/styles';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './Slider.css';

const useStyles = makeStyles((theme) => ({
  slick: {
    backgroundColor: '#fff',
    width: '100%'
  }
}));

export const Slick = ({ children, settings }) => {
  const classes = useStyles();
  return (
    <Slider style={{ position: 'relative' }} className={classes.slick} {...settings}>
      {children}
    </Slider>
  );
};
